/**
 * The external dependencies.
 */


export const getUsers = ({dispo: {users}}) => users;
export const getDepartments = ({dispo: {departments}}) => departments;
export const getDepartmentsConfig = ({dispo: {departmentsConfig}}) => departmentsConfig;





// WEBPACK FOOTER //
// ./src/store/dispo/selectors.js